import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue';
import router from './router';
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import directives from '@/directives/index';

import 'ant-design-vue/dist/antd.less';
import './assets/styles/theme.less';

import { createPinia } from 'pinia'
import LoginModal from './components/LoginModal.vue';
import AuthModal from './components/AuthModal.vue';

const app = createApp(App);
app.component('LoginModal', LoginModal);
app.component('AuthModal', AuthModal);
app.use(createPinia()).use(router).use(Antd).use(directives).use(mavonEditor).mount('#app')
